<template>
	<div v-if="!!visible || visible != false" id="header-component">
		<div class="field-container">
			<div v-for="field in header.fields" :key="field.name" :id="field.name" 
				@click="fieldOnClick(field, $event)" :class="{'invalid':field.invalid}">
				<div class="field" v-if="field.type=='date'" >
					<input type="month" v-model="header.data[field.name]" :placeholder="$t('month')" />
				</div>
				<v-select
					class="field"
					v-model="header.data[field.name]"
					:options="field.options"
					:label="field.selectLabel || 'label'"
					:value="field.selectValue || 'value'"
					:placeholder="field.label"
					@input="selectOnInput(field, $event)"
					v-if="field.type=='select'"
				><span slot="no-options">{{field.noOptionsText}}</span></v-select>
				<div class="field button" v-if="field.type=='button'" >
					{{field.label}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Util from '@/application/libs/util';
import eventModule from '@/application/libs/eventModule';
import moment from 'moment';
import DefaultHeaderController from '../controllers/DefaultHeaderController';
import InitialForm from '@/components/src/InitialForm';
import { t } from 'i18next';
const defaultNoOptionsText = "Nenhum dado encontrado.";
const noOptionsText = defaultNoOptionsText;

export default {
	name: "DefaultHeaderComponent",
	props:["visible"],
	components: {
		"v-select": VueSelect
	},
	created(){
		if(!this.boDataEventListenerBinded){
			eventModule.$on('updateBoData', this.onUpdateBoData);
			this.boDataEventListenerBinded = true;
		}
	},
	beforeDestroy(){
		eventModule.$off('updateBoData', this.onUpdateBoData);
		this.boDataEventListenerBinded = false;
	},
	mounted(){
		let unitField = this.header.fields.find(f=>f.name=="unit");
		DefaultHeaderController.getUnitData(unitField,{
			CDOPERADOR: Util.getLocalVar('userData').CDOPERADOR
		});

		let serviceField = this.header.fields.find(f=>f.name=="service");
		unitField.onInput = ()=>{
			this.header.data.service = null;
			this.loadServicesIntoField();
		};

		DefaultHeaderController.getServiceData(serviceField,{
			CDFILIAL: (Util.getFilterInSession() || {}).CDFILIAL
		});

		let submitBut = this.header.fields.find(f=>f.name=="submit");
		submitBut.onClick = function(){
			DefaultHeaderController.saveIfIsValid(this);
		}.bind(this);
		if(!Util.getFilterInSession().CDFILIAL){
			this.$modal.show(InitialForm, {}, {
				height:'auto',
				clickToClose: false
			});
		}
	},
	data() {
		return {
			header: {
				fields: [
					{
						name: "cardDate",
						type: "date",
						invalid: false
					},
					{
						name: "contract",
						type: "select",
						label: t('type_contract'),
						selectLabel:'NMCONTRATO',
						options:[
							{TPCONTRATO:'CONTRATO', NMCONTRATO: t('contract')},
							{TPCONTRATO:'PLANEJADO', NMCONTRATO: t('planned')}
						],
						invalid: false,
						noOptionsText
					},
					{
						name: "unit",
						type: "select",
						label: t('unit'),
						selectLabel:'NMFILIAL',
						options:[],
						invalid: false,
						noOptionsText
					},
					{
						name: "service",
						type: "select",
						label: t('service'),
						selectLabel: 'NMSERVICO',
						options: [],
						invalid: false,
						noOptionsText
					},
					{
						name: "submit",
						type: "button",
						label: t('apply')
					}
				],
				data: {
					cardDate: Util.getFilterInSession().DTMESCARD ?  
						moment(Util.getFilterInSession().DTMESCARD, 'DD/MM/YYYY').format('YYYY-MM')
						: '',

					contract: Util.getFilterInSession().TPCONTRATO ? {
						TPCONTRATO:Util.getFilterInSession().TPCONTRATO,
						NMCONTRATO:Util.getFilterInSession().NMCONTRATO
					} : '',

					unit: Util.getFilterInSession().CDFILIAL ? {
						CDFILIAL:Util.getFilterInSession().CDFILIAL,
						NMFILIAL:Util.getFilterInSession().NMFILIAL
					} : '',

					service:Util.getFilterInSession().CDSERVFILI ? {
						CDSERVFILI:Util.getFilterInSession().CDSERVFILI,
						NMSERVICO:Util.getFilterInSession().NMSERVICO
					} : ''
				}
			}
		};
	},
	methods:{
		fieldOnClick(field, event){
			if(field.onClick){
				field.onClick(event)
			}
		},
		selectOnInput(field, $event){
			if(field.onInput){
				field.onInput(event)
			}
		},
		loadServicesIntoField(){
			let serviceField = this.header.fields.find(f=>f.name=="service");
			if(this.header.data.unit && this.header.data.unit.CDFILIAL){
				DefaultHeaderController.getServiceData(serviceField,{
					CDFILIAL: this.header.data.unit.CDFILIAL
				});
			}
		},
		onUpdateBoData(){
			this.header.data.cardDate= moment(Util.getFilterInSession().DTMESCARD, 'DD/MM/YYYY').format('YYYY-MM');

			this.header.data.contract= {
				TPCONTRATO:Util.getFilterInSession().TPCONTRATO,
				NMCONTRATO:Util.getFilterInSession().NMCONTRATO
			};

			this.header.data.unit= {
				CDFILIAL:Util.getFilterInSession().CDFILIAL,
				NMFILIAL:Util.getFilterInSession().NMFILIAL
			};

			this.loadServicesIntoField();

			this.header.data.service = {
				CDSERVFILI:Util.getFilterInSession().CDSERVFILI,
				NMSERVICO:Util.getFilterInSession().NMSERVICO
			};
		},
	}
};
</script>

<style lang="less">
@import (reference) url("../../assets/variables.less");

#header-component {
	background: @azul;
	width: 100%;
	height: 48px;
	margin-bottom: 5px;

	.field-container{
		display: flex;

		&>div{
			margin: 5px;
			display: inline-block;
			flex:1;
			max-width: 20%;
			height: 34px;

			&.invalid{
				.field{
					border: 2px solid @vermelho;
				}
			}
		}

		
		.field{
			height:100%;
			width: 100%;
			font-size: 1rem;

			box-sizing: border-box;
			border-radius: 4px;
			text-align: left;
			background-color:white;
			border:none;

			&.button{
				background-color:@vermelho;
				padding: 8px 0;
				text-align: center;
			}
		}

		// .v-select.field{
		// 	.field;

		// 	.vs__dropdown-toggle{
		// 		height: 100%;
		// 		overflow:hidden;
		// 	}
		// }

		.v-select.field{
			.vs__selected-options {
			flex-wrap: nowrap;
			max-width: calc(100% - 41px);
			}

			.vs__selected {
				display: block;
				white-space: nowrap;
				text-overflow: ellipsis;
				max-width: 100%;
				overflow: hidden;
			}

			// .vs__search {
			// 	position: absolute;
			// }

			// .vs--open .vs__search {
			// 	position: static;
			// }
			
			.vs__dropdown-menu{
				width: max-content;
			}

			.vs__dropdown-toggle{
				height: 100%;
			}

			.vs__dropdown-option {
			white-space: normal;
			}
		}
		.v-select.field.vs--searching{
			.vs__selected {
				display: none;
			}
		}
		input[type="month"], input[type="date"]{
			.field;

			&:before {
				content: attr(placeholder)+': ' !important;
				font-family: Arial;
				font-size: 1em;
				margin-left: 0.5em;
				margin-right: 0.3em;
			}

			&::-webkit-datetime-edit {
				font-family: Arial;
				font-size: 1em;
			}

			&::-webkit-inner-spin-button{
				position:relative;
				top: 7px;
			}
		}
	}
}
</style>